import { Directive, ElementRef, OnDestroy, inject } from '@angular/core';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Subscription, tap } from 'rxjs';
import { ReadonlyService } from 'src/app/core/services/readonly.service';

@Directive({ selector: '[appDisableInput]' })
export class DisableInputDirective implements OnDestroy {
  private elementRef = inject<ElementRef<any>>(ElementRef);
  private readonlySvc = inject(ReadonlyService);

  private sub = new Subscription();

  constructor() {
    const readonlySvc = this.readonlySvc;

    this.sub.add(
      readonlySvc
        .getReadonly()
        .pipe(
          tap((isReadonly) => {
            if (isReadonly) {
              this.elementRef.nativeElement.style.pointerEvents = 'none';
            } else {
              this.elementRef.nativeElement.style.pointerEvents = 'initial';
            }
          })
        )
        .subscribe()
    );
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
